import { Brand } from '../ui/brand';
import { Mascot } from '../ui/mascot';
import { cx } from '../ui/styles';

const subjects = [
  { name: 'Rekenen', tone: 'bg-orange-100 text-orange-900' },
  { name: 'Spelling', tone: 'bg-brand-100 text-brand-900' },
  { name: 'Begrijpend lezen', tone: 'bg-leaf-100 text-leaf-800' },
];

export function WormScene({ className }: { readonly className?: string }) {
  return (
    <div aria-hidden="true" className={cx('relative aspect-square', className)}>
      <div className="absolute inset-[9%] rounded-full bg-brand-200/70 ring-8 ring-white/25" />
      <Mascot pose="study" size="fit" className="absolute inset-x-0 bottom-[12%] mx-auto h-[68%]" />
    </div>
  );
}

export function LoginShowcase() {
  return (
    <aside className="relative hidden overflow-hidden bg-brand-500 lg:sticky lg:top-0 lg:flex lg:h-screen lg:flex-col">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-doodles-light" />
      <div className="relative px-12 pt-10 xl:px-16">
        <Brand size="lg" tone="light" />
      </div>
      <div className="relative flex min-h-0 flex-1 items-center justify-center px-12 pb-4">
        <WormScene className="h-full max-h-[26rem] max-w-full" />
      </div>
      <div className="relative">
        <svg
          viewBox="0 0 720 60"
          preserveAspectRatio="none"
          aria-hidden="true"
          className="block h-12 w-full fill-white"
        >
          <path d="M0 34 C120 4 240 4 360 30 C480 56 600 56 720 22 V60 H0 Z" />
        </svg>
        <div className="bg-white px-12 pt-2 pb-12 xl:px-16">
          <h2 className="max-w-xl font-rounded text-[2.75rem] leading-[1.05] font-semibold tracking-tight text-balance text-brand-950 xl:text-5xl">
            Elke dag een beetje beter met Oefy.
          </h2>
          <p className="mt-4 max-w-lg text-lg leading-relaxed text-pretty text-slate-600">
            Speels oefenen op eigen tempo voor kinderen van{' '}
            <span className="whitespace-nowrap">groep 3 t/m 8.</span> Perfect ter voorbereiding op
            Cito, IEP en de Doorstroomtoets.
            <a href="#toelichting" className="text-slate-400 no-underline hover:text-brand-700">
              *
            </a>
          </p>
          <ul className="mt-6 flex flex-wrap gap-2">
            {subjects.map((subject) => (
              <li
                key={subject.name}
                className={cx('rounded-full px-3 py-1 text-sm font-semibold', subject.tone)}
              >
                {subject.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  );
}
